/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { ProxyChallengeOptions } from './ProxyChallengeOptions';
import {
    ProxyChallengeOptionsFromJSON,
    ProxyChallengeOptionsFromJSONTyped,
    ProxyChallengeOptionsToJSON,
} from './ProxyChallengeOptions';

/**
 * 
 * @export
 * @interface ProxyChallenge
 */
export interface ProxyChallenge {
    /**
     * 
     * @type {string}
     * @memberof ProxyChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof ProxyChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof ProxyChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {ProxyChallengeOptions}
     * @memberof ProxyChallenge
     */
    options?: ProxyChallengeOptions;
}

/**
 * Check if a given object implements the ProxyChallenge interface.
 */
export function instanceOfProxyChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function ProxyChallengeFromJSON(json: any): ProxyChallenge {
    return ProxyChallengeFromJSONTyped(json, false);
}

export function ProxyChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': !exists(json, 'options') ? undefined : ProxyChallengeOptionsFromJSON(json['options']),
    };
}

export function ProxyChallengeToJSON(value?: ProxyChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': ProxyChallengeOptionsToJSON(value.options),
    };
}

